import { Paginated, RequestedFeature } from "@vixi/types";

export const optimisticDownvote =
  (featureId: RequestedFeature["id"]) =>
  (oldData: Paginated<RequestedFeature> | undefined): Paginated<RequestedFeature> | undefined => {
    if (!oldData) return undefined;

    const newData = { ...oldData };
    const items = newData.items ?? [];
    if (items.length === 0) return newData;

    const updatedFeatureIndex = items.findIndex((feature) => feature.id === featureId);
    if (updatedFeatureIndex !== -1) {
      items[updatedFeatureIndex] = {
        ...items[updatedFeatureIndex],
        votes: Math.max(0, items[updatedFeatureIndex].votes - 1),
        isVoted: false,
      };
    }
    newData.items = items;

    return {
      ...newData,
      items: [...items],
    };
  };

export const optimisticUpvote =
  (featureId: RequestedFeature["id"]) =>
  (oldData: Paginated<RequestedFeature> | undefined): Paginated<RequestedFeature> | undefined => {
    if (!oldData) return undefined;

    const newData = { ...oldData };
    const items = newData.items ?? [];
    if (items.length === 0) return newData;

    const updatedFeatureIndex = items.findIndex((feature) => feature.id === featureId);
    if (updatedFeatureIndex !== -1) {
      items[updatedFeatureIndex] = {
        ...items[updatedFeatureIndex],
        votes: items[updatedFeatureIndex].votes + 1,
        isVoted: true,
      };
    }
    newData.items = items;

    return {
      ...newData,
      items: [...items],
    };
  };
